import { DOCUMENT_TYPES_ACTIONS } from "constants/Actions/DocumentTypes";

// Estado inicial del reducer
const aInitialState = {
    aTypes: [],
    oType: null,

    bIsSuccess: false,
    bIsError: false,
}
/**
 * Reducer que sera utilizado para controlar los datos referidos a los tipos de documentos que admite el sistema.
 * 
 * @param {Array} aState Estado, si no recibe datos se setea el estado inicial
 * @param {object} oAction Action que es ejecutada
 * 
 * @returns {Array} Retorna un array que sera seteado en el estado del reducer
 * 
 * @author Leandro Curbelo 
 */
export const DocumentTypeReducer = (aState = aInitialState, oAction) => {
    switch (oAction.type) {
        case DOCUMENT_TYPES_ACTIONS.GET:
            return { ...aState, aTypes: oAction.data };
        case DOCUMENT_TYPES_ACTIONS.CLEAN:
            return { ...aState, bIsSuccess: false, bIsError: false, oType: null };
        case DOCUMENT_TYPES_ACTIONS.FIND:
            return { ...aState, oType: oAction.data };
        case DOCUMENT_TYPES_ACTIONS.SUCCESS:
            return { ...aState, bIsSuccess: true };
        case DOCUMENT_TYPES_ACTIONS.ERROR:
            return { ...aState, bIsError: true };
        default:
            return aState;
    }
}
